import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import { AppState } from '../../../store'
import { IManualVerificationReturnModel } from '../models/IManualVerificationPageModel'
import {  SET_HAS_CLIENT_CONSENT_MANUAL_VERIFICATION } from '../../../store/actions/application-actions'
import applicationService from '../../../service/application.service'
import { SessionStorage } from '../../../common/cookie-storage'
import { STORAGEKEYS } from '../../../common/keys'
import { sleep } from '../../../common/helpers/helpers'
import {
   useGetManualVerificationContentBasedOnBackendData,
   useGetManualVerificationContentDetailsBasedOnBackendData
} from './useGetManualVerificationContentBasedOnBackendData'
import analyticsService from '../../../service/analytics.service'


/**
 * Custom hook obsługujący logikę strony weryfkacji manualnej użytkownika
*/
const useManualVerificationPageLogic = (): IManualVerificationReturnModel => {
   const dispatch = useDispatch()
   const manualVerificationContent = useGetManualVerificationContentBasedOnBackendData()
   const manualVerificationContentDetails = useGetManualVerificationContentDetailsBasedOnBackendData()

   const [ htmlContentBasedOnDate ] = useState(() => manualVerificationContent)
   const [ htmlContentDetailsBasedOnDate ] = useState(() => manualVerificationContentDetails)

   const [isConfirmationButtonLoading, setIsConfirmationButtonLoading] = React.useState<boolean>(false)
   const { hasClientConsentManualVerification, clientConsentManualVerificationHasError, workFrom} = useSelector((state: AppState) => state.applicationState.manualVerificationState)
   const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)
   

   const confirmManualVerificationDefaultMethod = useCallback(async() => {
      setIsConfirmationButtonLoading(true)
      const sessionStorage = new SessionStorage()
      const alphaId = sessionStorage.get(STORAGEKEYS.SET_ALPHA_ID)

      try {
         if (true) {
            const signApplicationResponse = (await applicationService.confirmManualVerificationDefaultMethod({ test: "verificationCode" }).then((p) => p))         
            await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.ManualVerificationConfirmButtonClicked)     

            dispatch({ 
               type: SET_HAS_CLIENT_CONSENT_MANUAL_VERIFICATION,
               payload: signApplicationResponse.isOk
            })
         }

         await sleep(1500)
      }
      catch (error) {
         console.error("Błąd podczas potwierdzania domyślnej metody weryfikacji manualnej", error)
      }
      finally {
         setIsConfirmationButtonLoading(false)
      }
   }, [dispatch])
   
 
   return {
      confirmManualVerificationDefaultMethod,
      htmlContentBasedOnDate,
      htmlContentDetailsBasedOnDate,
      hasClientConsentManualVerification,
      clientConsentManualVerificationHasError,
      isConfirmationButtonLoading,
   }
 }
 
 export default useManualVerificationPageLogic